<!-- 组件说明 -->
<template>
  <a-form-model-item
    label="班主任"
    :labelCol="labelCol"
    :wrapperCol="wrapperCol"
    prop="teacher"
  >
    <a @click="choocetea = !choocetea">选择班主任</a>
    <a-drawer
      title="选择班主任"
      width="650"
      :closable="false"
      :body-style="{ paddingBottom: '80px' }"
      :visible="choocetea"
      @close="onClosetea"
    >
      <a-table
        ref="table"
        size="small"
        :columns="columns"
        :dataSource="data"
        :rowKey="r => r.key"
        v-model="teacherList"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'radio'
        }"
      ></a-table>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClosetea">
          取消
        </a-button>
        <a-button type="primary" @click="isok">
          确定
        </a-button>
      </div>
    </a-drawer>
    <div>
      <a-tag
        v-for="(item, index) in selectionRows"
        :key="index"
        closable
        @close.prevent="closeUserTag(index)"
      >
        {{ item.name }}
      </a-tag>
    </div>
    <a-input
      :max-length="3"
      style="width: 100px;display:none"
      placeholder="请输入"
      v-model="teaform.teacher"
    ></a-input>
  </a-form-model-item>
</template>

<script>
import { courseTeacherList } from '@/api/api';

const columns = [
  {
    title: '成员姓名',
    dataIndex: 'name'
  },
  {
    title: '进群时间',
    dataIndex: 'joinTime'
  }
];
export default {
  props: ['teaform', 'groupChatId', 'headmasterId', 'headmasterName'],
  components: {},
  data() {
    return {
      columns,
      data: [],
      selectedRowKeys: [],
      selectionRows: [],
      choocetea: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      teacherTagList: [],
      teacherTagKeys: [],
      teacherList: []
    };
  },
  computed: {},
  methods: {
    // 关闭弹窗
    onClosetea() {
      this.choocetea = false;
    },
    // 确认回调
    isok() {
      this.teacherTagList = this.selectionRows;
      this.teacherTagKeys = this.selectedRowKeys;
      this.teacherList = this.selectedRowKeys;
      this.choocetea = false;
      this.teaform.teacher = this.selectionRows;
    },
    // 选择改变回调
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.selectionRows, '>>>>');
    },
    // 删除标签
    closeUserTag(i) {
      console.log(this.selectedRowKeys, i);
      this.selectionRows.splice(i, 1);
      this.selectedRowKeys.splice(i, 1);
      this.teacherList.splice(i, 1);
    },
    // 获取班主任列表
    getTeacherList() {
      if (this.groupChatId) {
        courseTeacherList({
          chatId: this.groupChatId
        }).then(res => {
          if (res.success) {
            this.data = res.result.result;
            this.data.map(e => (e.key = e.userId));
          }
        });
      }
    }
  },
  watch: {},
  mounted() {
    this.getTeacherList();
  }
};
</script>

<style scoped></style>
